import { render, staticRenderFns } from "./ProdesResiduosCerrado.vue?vue&type=template&id=38b801a0&lang=pug"
import script from "./ProdesResiduosCerrado.vue?vue&type=script&lang=js"
export * from "./ProdesResiduosCerrado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports